import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import './StepIndicator.less';

function StepIndicator({ currentStep, cancelLink }) {
  const history = useHistory();
  const steps = [
    { key: 'select', label: 'Select plan' },
    { key: 'review', label: 'Review and pay' }
  ];

  const handleBack = () => {
    history.goBack();
  };

  return (
    <div className='step-indicator'>
      {currentStep > 1 && (
        <a onClick={handleBack} className='back-link'>← Back</a>
      )}
      <div className={classNames('steps', `current-step-${currentStep}`)}>
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <React.Fragment key={step.key}>
              {index > 0 && <div className='step-line' />}
              <div className={classNames('step', { active: isActive, completed: isCompleted })}>
                <div className='step-circle'></div>
                <span className='step-label'>{step.label}</span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <Link to={cancelLink || '/subscriptions'} className='cancel-link'>Cancel</Link>
    </div>
  );
}

StepIndicator.defaultProps = {
  currentStep: 1,
  cancelLink: '/subscriptions'
};

export default StepIndicator;

StepIndicator.displayName = 'StepIndicator'
